import { TextField } from 'module/types/filter-field/field/filterable-field';
import { Input as RawInput } from 'module/ui/components/atoms/input/input';
import { NoValue as EmptyCell } from 'module/ui/components/atoms/no-value/empty-cell';
import { FC } from 'react';
import { EditableProps } from './editable-props';

const Input = RawInput;

interface Props extends Partial<EditableProps<string>> {
  field: TextField;
}

export const TextFieldValue: FC<Props> = ({
  field,
  id,
  editable,
  onChange,
  onKeyDown,
}) =>
  !editable ? (
    field.value == null || field.value === '' ? (
      <EmptyCell />
    ) : (
      <>{field.value}</>
    )
  ) : (
    <Input
      id={id}
      data-cy={`ag-grid.${field.type}.editor`}
      autoFocus
      value={field.value}
      onChange={(event) => onChange?.(event.target.value)}
      onKeyDown={onKeyDown}
      disabled={!editable}
    />
  );

export const TextInput: FC<Props> = ({
  field,
  id,
  editable,
  onChange,
  onKeyDown,
}) => {
  return (
    <Input
      id={id}
      data-cy={`ag-grid.${field.type}.editor`}
      autoFocus
      value={field.value}
      onChange={(event) => onChange?.(event.target.value)}
      onKeyDown={onKeyDown}
      disabled={!editable}
    />
  );
};
